import { Flex, Space } from "antd";
import { AppRadio, AppText, AppTitle, RadioGroup } from "@/shared/Components";
import { priceFormat } from "@/shared/utils";
import { getPricePostfix, getSafeLocalizedValue } from "@/features/payment-form/model/utils";
import type { RadioChangeEvent } from "antd";
import type { SelectedTariffOption, TariffOption } from "@/services/api/entities/payment/types";
import styles from "./styles.module.scss";

type Props = {
  option: TariffOption;
  selectedTariffOptions: SelectedTariffOption[];
  handleChangeOptionItem: (optionId: string, optionItemId: string) => void;
};

export const TariffOptionView = ({
  option,
  selectedTariffOptions,
  handleChangeOptionItem,
}: Props) => {
  const optionValue = selectedTariffOptions.find((item) => item.optionId === option.id);

  const onChange = (event: RadioChangeEvent) => {
    handleChangeOptionItem(option.id, event.target.value);
  };

  return (
    <Flex gap={12} vertical className={styles.option}>
      <AppTitle level={3} type="secondary" className={styles.title}>
        {getSafeLocalizedValue(option.localizedName, option.name)}
      </AppTitle>
      <RadioGroup value={optionValue?.optionItemId} onChange={onChange}>
        <Flex vertical gap={12}>
          {option.items.map((item) => (
            <AppRadio key={item.id} className={styles.radio} value={item.id}>
              <Flex justify="space-between" className={styles["option-item"]}>
                <Space className={styles["option-item-description"]}>
                  {getSafeLocalizedValue(item.localizedName, item.name)}
                </Space>
                <Space className={styles["price-wrapper"]}>
                  <AppText
                    className={styles.price}
                  >{`${priceFormat(item.price)}${getPricePostfix(item.countFrequency)}`}</AppText>
                </Space>
              </Flex>
            </AppRadio>
          ))}
        </Flex>
      </RadioGroup>
    </Flex>
  );
};
